'use client';

import { Center } from '@chakra-ui/react';
import { LoadingIndicator } from './LoadingIndicator';

/** A plain spinner inside the existing route or app content region. */
export function AppLoadingSpinner({ minH = '100dvh' }: { minH?: string }) {
  return (
    <Center minH={minH} w="full">
      <LoadingIndicator size="md" label="Loading Attune" />
    </Center>
  );
}
